import { useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FaFilter } from "react-icons/fa";
import Grid from "@mui/material/Grid";
import SoftSelect from "components/SoftSelect";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import SoftDatePicker from "components/SoftDatePicker";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import SoftButton from "components/SoftButton";
import Drawer from "@mui/material/Drawer";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Paper, Typography } from "@mui/material";
import { FaHome, FaUserMd, FaHeartbeat } from "react-icons/fa";
import { MdPregnantWoman, MdDashboardCustomize } from "react-icons/md";
import { TbVaccine } from "react-icons/tb";

const allTitles = [
	{ title: "Immunization Coverage" },
	{ title: "Avg Patient Waiting Time" },
	{ title: "Avg Patient Journey Time" },
	{ title: "Maternal Health Check-ups" },
	{ title: "TB Case Detection Rate" },
	{ title: "HIV Treatment Adherence" },
	{ title: "Malaria Prevention Coverage" },
	{ title: "Nutrition Program Reach" },
	{ title: "ABHA Creation Rate" },
	{ title: "Bed Occupancy Rate" },
	{ title: "Emergency Response Time" },
	{ title: "Readmission Rate" },
	{ title: "Staff-to-Patient Ratio" },
	{ title: "Staffing Gaps" },
];
const navigationItems = [
	{
		title: "Health Secratory Dashboard",
		icon: <MdDashboardCustomize size={18} />,
		path: "/#Dashboard",
	},
	{
		title: "Maharashtra Healthcare Dashboard",
		icon: <MdDashboardCustomize size={18} />,
		path: "/#healthcare-infrastructure-dashboard",
	},
	{
		title: "Maternal Dashboard",
		icon: <MdPregnantWoman size={18} />,
		path: "/#Maternal-Health-Dashboard",
	},
	{
		title: "Health Intelligence Dashboard",
		icon: <FaHeartbeat size={18} />,
		path: "/#Health-Intelligence-Dashboard",
	},
	{
		title: "Mother & Child Care Dashboard",
		icon: <FaHeartbeat size={18} />,
		path: "/#Mother-Child-Healthcare-Dashboard",
	},
	{
		title: "Integrated Health Dashboard",
		icon: <FaHeartbeat size={18} />,
		path: "/#Integrated-Health-Dashboard",
	},
	
	// {
	// 	title: "RMNCH Dashboard",
	// 	icon: <FaHeartbeat size={18} />,
	// 	path: "/#RMNCH-Dashboard",
	// },

	// {
	//   title: "TB Dashboard",
	//   icon: <TbVaccine size={18} />,
	//   path: "/tb-dashboard",
	// },
	// {
	//   title: "Doctors & Staff",
	//   icon: <FaUserMd size={18} />,
	//   path: "/staff",
	// },
	// {
	//   title: "Home",
	//   icon: <FaHome size={18} />,
	//   path: "/home",
	// },
];
export const cardIconColor = "bg-[#428bab]"; //"bg-[#426eab]";
function Header({ onSearchChange, onMenuClick, selected, setSelected, dashboardName }) {

	const [showFilters, setShowFilters] = useState(false);
	const [selectedDistrict, setSelectedDistrict] = useState("");
	const [showSettings, setShowSettings] = useState(false);
	const [openNav, setOpenNav] = useState(false);
	const [showSidebar, setShowSidebar] = useState(false); // <--- for left menu

	const [available, setAvailable] = useState(allTitles.slice(5));

	const districts = [
		{ value: "", label: "Select" },
		{ value: "Mumbai", label: "Mumbai" },
		{ value: "Nashik", label: "Nashik" },
		{ value: "Pune", label: "Pune" },
		{ value: "Latur", label: "Latur" },
	];

	const onDragEnd = (result) => {
		if (!result.destination) return;
		const { source, destination } = result;

		if (source.droppableId === destination.droppableId) {
			if (source.droppableId === "available") {
				const updated = Array.from(available);
				const [moved] = updated.splice(source.index, 1);
				updated.splice(destination.index, 0, moved);
				setAvailable(updated);
			} else {
				const updated = Array.from(selected);
				const [moved] = updated.splice(source.index, 1);
				updated.splice(destination.index, 0, moved);
				setSelected(updated);
			}
		} else {
			if (source.droppableId === "available") {
				const avail = Array.from(available);
				const sel = Array.from(selected);
				const [moved] = avail.splice(source.index, 1);
				sel.splice(destination.index, 0, moved);
				setAvailable(avail);
				setSelected(sel);
			} else {
				const avail = Array.from(available);
				const sel = Array.from(selected);
				const [moved] = sel.splice(source.index, 1);
				avail.splice(destination.index, 0, moved);
				setAvailable(avail);
				setSelected(sel);
			}
		}
	};

	return (
		<>
			{/* === TOP HEADER === */}
			<SoftBox
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				px={3}
				py={1}
				bgColor="white"
				boxShadow="sm"
				borderRadius="md"
				style={{ height: "6vh" }}
			>
				{/* Left Menu Button */}
				<IconButton onClick={() => setOpenNav(true)}>
					<MenuIcon />
				</IconButton>

				{/* Title */}
				<SoftTypography variant="h5" fontWeight="bold" color="dark">
					{dashboardName}
				</SoftTypography>

				{/* Filter */}
				<IconButton onClick={() => setShowFilters(!showFilters)}>
					<FaFilter />
				</IconButton>
			</SoftBox>

			{/* ============================= */}
			{/* === LEFT SIDEBAR ADDED HERE === */}
			{/* ============================= */}

			<Drawer
				anchor="left"
				open={openNav}
				onClose={() => setOpenNav(false)}
				PaperProps={{
					sx: {
						width: 290,
						padding: 0,
						backgroundColor: "#ffffff",
						boxShadow: "0 6px 30px rgba(0,0,0,0.15)",
						borderRight: "1px solid #e5e7eb",
					},
				}}
			>
				<div className="h-full flex flex-col">

					{/* Top Brand Header */}
					<div className="px-5 py-4 border-b border-gray-200">
						<h1 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
							<span className="w-2 h-2 bg-blue-600 rounded-full"></span>
							Dashboards
						</h1>
					</div>

					{/* Menu Items */}
					<div className="flex-1 overflow-y-auto px-3 py-4 space-y-1">

						{/* MAIN MENU */}
						<div>
							<p className="text-[11px] font-semibold uppercase text-gray-400 px-2 mb-2">
								Main Menu
							</p>

							{navigationItems.slice(0, 10).map((item) => (
								<div
									key={item.id}
									onClick={() => {
										window.location.href = item.path;
										setOpenNav(false);
									}}
									className="
              flex items-center gap-3 
              px-3 py-2.5
              rounded-lg text-[15px]
              text-gray-700 font-medium
              cursor-pointer
              hover:bg-gray-100 
              hover:text-blue-600
              transition-all
			  text-wrap
            "
								>
									<span className="text-gray-500 text-lg">{item.icon}</span>
									{item.title}
								</div>
							))}
						</div>

						{/* Divider */}
						<div className="my-3 border-t border-gray-200"></div>

						{/* PREFERENCES */}
						{/* <div>
							<p className="text-[11px] font-semibold uppercase text-gray-400 px-2 mb-2">
								Preferences
							</p>

							{navigationItems.slice(5).map((item) => (
								<div
									key={item.id}
									onClick={() => {
										window.location.href = item.path;
										setOpenNav(false);
									}}
									className="
              flex items-center gap-3 
              px-3 py-2.5
              rounded-lg text-[15px]
              text-gray-700 font-medium
              cursor-pointer
              hover:bg-gray-100 
              hover:text-purple-600
              transition-all
            "
								>
									<span className="text-gray-500 text-lg">{item.icon}</span>
									{item.title}
								</div>
							))}
						</div> */}

					</div>
				</div>
			</Drawer>


			{/* -------------------------------- */}
			{/* REMAINING FILTER AREA (unchanged) */}
			{/* -------------------------------- */}

			{showFilters && (
				<SoftBox mt={2} px={3}>
					<Grid container spacing={2}>
						{/* <Grid item xs={12} md={3}>
							<TextField
								fullWidth
								placeholder="Search Indicators"
								variant="outlined"
								onChange={(e) => onSearchChange(e.target.value)}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon />
										</InputAdornment>
									),
								}}
							/>
						</Grid> */}

						<Grid item xs={12} md={2}>
							<SoftSelect
								options={districts}
								value={selectedDistrict}
								onChange={setSelectedDistrict}
								placeholder="Select District"
							/>
						</Grid>

						{/* <Grid item xs={12} md={2}>
							<SoftDatePicker
								input={{ placeholder: "Select Date Range" }}
								options={{ mode: "range", dateFormat: "d-m-Y" }}
							/>
						</Grid> */}
						<Grid item xs={12} md={2}>
							<SoftDatePicker
								input={{ placeholder: "Select Month" }}
								options={{
									dateFormat: "F Y", // Show Month + Year
									defaultDate: new Date(), // Pre-select current month

									plugins: [
										new monthSelectPlugin({
											shorthand: false,
											dateFormat: "F Y",   // Display format
											altFormat: "F Y",
											theme: "light"
										})
									]
								}}
							/>
						</Grid>
						<Grid item xs={12} md={1}>
							<SoftButton variant="gradient" color="info">
								Apply
							</SoftButton>
						</Grid>
					</Grid>
				</SoftBox>
			)}

			{/* === KPI Drawer (unchanged) === */}
			{/** ... your full KPI drawer code stays untouched ... */}
		</>
	);
}

export default Header;
